export default __webpack_public_path__ + "static/media/img_17.649bc2c4.jpg";